import { ClipboardList, MessagesSquare, Layers, ShieldCheck } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";

const PILLARS = [
  {
    icon: ClipboardList,
    title: "Perencanaan Proyek yang Jelas",
    text: "Lingkup pekerjaan, jadwal, dan biaya disusun secara tertulis sebelum pengerjaan dimulai.",
  },
  {
    icon: MessagesSquare,
    title: "Komunikasi Terbuka dengan Klien",
    text: "Anda selalu tahu perkembangan proyek dan dapat berdiskusi kapan saja.",
  },
  {
    icon: Layers,
    title: "Material Sesuai Kebutuhan",
    text: "Pemilihan material disesuaikan dengan fungsi, anggaran, dan umur pakai bangunan.",
  },
  {
    icon: ShieldCheck,
    title: "Fokus pada Mutu & Keselamatan",
    text: "Standar mutu dan keselamatan kerja menjadi dasar setiap keputusan di lapangan.",
  },
];

export const Keunggulan = () => (
  <section
    data-testid="keunggulan-band"
    className="relative overflow-hidden bg-navy"
    aria-label="Keunggulan kami"
  >
    <div className="navy-grid-bg absolute inset-0" aria-hidden="true" />
    <div
      className="absolute -left-24 top-1/2 h-96 w-96 -translate-y-1/2 rounded-full bg-orange-500/10 blur-3xl"
      aria-hidden="true"
    />
    <div className="relative mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-12 lg:py-28">
      <Reveal className="max-w-2xl">
        <Eyebrow light>Keunggulan</Eyebrow>
        <h2 className="text-balance font-heading text-3xl font-extrabold leading-tight tracking-tight text-white sm:text-4xl">
          Cara Kami Bekerja, dari Awal hingga{" "}
          <span className="italic text-orange-500">Serah Terima</span>
        </h2>
      </Reveal>

      <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {PILLARS.map((pillar, i) => (
          <Reveal key={pillar.title} delay={i * 0.08} className="h-full">
            <article
              data-testid={`keunggulan-item-${i + 1}`}
              className="group flex h-full flex-col rounded-2xl border border-white/10 bg-white/5 p-6 backdrop-blur-sm transition-[background-color,border-color,transform] duration-300 hover:-translate-y-1 hover:border-orange-500/40 hover:bg-white/10 sm:p-7"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-orange-500/15">
                <pillar.icon className="h-5 w-5 text-orange-400" aria-hidden="true" />
              </span>
              <h3 className="mt-5 font-heading text-base font-bold text-white">
                {pillar.title}
              </h3>
              <p className="mt-2.5 text-sm leading-relaxed text-slate-300">
                {pillar.text}
              </p>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
